module.exports = __webpack_public_path__ + "img/p9.8bfc4b5b.png";